// Form1.js
import React, { useState, useRef } from 'react';
import ChatBox from '../../custom_elements/ChatBox';
import { CustomInput, validationRules } from '../../custom_elements/CustomInput';
import CustomSelect from '../../custom_elements/CustomSelect';

export default function Form6({ nextForm, passGetFormData, passValidateAllFormFields, retrievedFormData = {}, sendChat}) {
    const formRefs = useRef([]);  // Reference array to store refs of CustomInput fields

    const getFormData = () => {
        console.log("INSIDE GETFORMDATA on Form7");
        const form = document.getElementById('Form7');
        const formData = new FormData(form);
        const data = {};
        for (let [key, value] of formData.entries()) {
            data[key] = value;
        }
        return {person: [data], kommentar: formData.get('kommentar')};
    };

    React.useEffect(() => {
        console.log('Form7 mounted');
        passGetFormData(() => getFormData); // Pass the getFormData function to the parent
    }, [passGetFormData]);

    return (
        <div className="formFieldBox">
            <form id="Form7">
                {(
                    <div className="success-message-container" style={{marginTop: "30px", textAlign: "center"}}>
                        <div style={{ fontSize: "60px", color: "green" }}>✔</div>
                        <h2 style={{ color: "green", marginTop: "10px" }}>Vielen Dank!</h2>
                        <p>Deine Anfrage wurde erfolgreich übermittelt. Wir melden uns in Kürze bei dir!</p>
                    </div>
                )}
            </form>
        </div>
    );
}
